import { Controller } from "@hotwired/stimulus"

// Shell controller for the Vocabulary Set wizard. Matches the shape of
// vocabulary_wizard_controller (its single-card sibling). Current duties
// are limited to exposing configId + step values to nested controllers;
// cross-step state lives in the URL (active_card_index param) and the
// backend, not in this controller.
export default class extends Controller {
  static values = {
    configId: Number,
    step: String,
  }

  connect() {
    // Intentionally empty. Hook here if the wizard grows client-side
    // navigation or unsaved-change warnings.
  }
}
